module.exports = __webpack_public_path__ + "img/photo-2.09886b0d.jpg";